import { initSaleSearch } from 'features/search/saleSearch';

function initSearchSale () {

	initSaleSearch('.saleSearchBox #searchSalePage', '.saleSearchBox #searchBtnSalePage');

}

export default initSearchSale;
